import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_TOP_SELLING_CAMPAIGN_PRODUCTS = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}

  query GetTopSellingCampaignProducts($numberOfProducts: Int!) {
    topSellingCampaignProducts(numberOfProducts: $numberOfProducts) {
      products {
        ...ProductReference
      }
    }
  }
`
